$(document).ready(function() {

  $(".js-form-label").on("click", function () {
    $(this).parents(".js-form-field").addClass("is-active");
    $(this).parents(".js-form-field").find(".js-form-input").focus();
});

$(".js-form-input").on("blur", function () {
    if ($(this).val().length >= 1) {} else {
        $(this).parents(".js-form-field").removeClass("is-active");
    }
});

  $(".js-popup-close").on("click", function () {
    var popup = $(this).parents(".js-popup");

    $(popup).removeClass("is-active");
    $("body").removeClass("is-hidden");
  });

  $(document).on("click", function (e) {
    var popup = $(".js-popup");
    if (popup.is(e.target)) {
      $(popup).removeClass("is-active");
      $("body").removeClass("is-hidden");
    }
  });

  $(".js-popup-open").on("click", function () {
    var name = $(this).data("popup");

    $(".js-popup[data-popup='" + name + "']").addClass("is-active");
    $("body").addClass("is-hidden");

    return false;
  });
  $('.js-review').slick({
    slidesToShow: 2,
    arrows: true,
    dots: true,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev">\
    <svg width="16" height="30" viewBox="0 0 16 30" fill="none" xmlns="http://www.w3.org/2000/svg">\
      <path d="M15.1494 29L2 15L15.1494 0.999999" stroke-width="2"/>\
    </svg>\
        </button>',
    nextArrow: '<button type="button" class="slick-next">\
    <svg width="16" height="30" viewBox="0 0 16 30" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path d="M0.850572 0.999999L14 15L0.85057 29"  stroke-width="2"/>\
    </svg>\
    </button>',
  
    responsive: [
      {
        breakpoint: 1100,
        settings: {
            slidesToShow: 1,
            dots: true,
        }
      }
    ]
});

$(".js-hamburger").on("click" , function(){
  $(".js-mobile-menu").addClass("is-open");
});

$(".js-mobile-menu-close").on("click" , function(){
  $(".js-mobile-menu").removeClass("is-open");
})


$(".js-phone").mask("+7(999)999-99-99");

$(".js-submit").on("click" , function(){
  $(this).parents(".js-form").find(".js-form-ok").addClass("is-active");
  
  setTimeout(function () {
    $(".js-form-ok").removeClass("is-active");
  }, 1000);
  return false;
})


$('.js-review').slick({
    slidesToShow: 3,
    arrows: true,
    dots: true,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev">\
    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path d="M0.978027 0.5L5.56509 4.62835C5.78578 4.82697 5.78578 5.17303 5.56509 5.37165L0.978027 9.5" stroke="#333333" stroke-linecap="round"/>\
    </svg>\
        </button>',
    nextArrow: '<button type="button" class="slick-next">\
    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path d="M0.978027 0.5L5.56509 4.62835C5.78578 4.82697 5.78578 5.17303 5.56509 5.37165L0.978027 9.5" stroke="#333333" stroke-linecap="round"/>\
    </svg>\</button>',
  
    responsive: [
      {
        breakpoint: 992,
        settings: {
            variableWidth: true,
            slidesToShow: 1,
            dots: true,
            variableWidth: true
        }
      }
    ]
});

$(".js-article-link").slick({
    slidesToShow: 5,
    arrows: true,
    dots: true,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev">\
    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path d="M0.978027 0.5L5.56509 4.62835C5.78578 4.82697 5.78578 5.17303 5.56509 5.37165L0.978027 9.5" stroke="#333333" stroke-linecap="round"/>\
    </svg>\
        </button>',
    nextArrow: '<button type="button" class="slick-next">\
    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">\
    <path d="M0.978027 0.5L5.56509 4.62835C5.78578 4.82697 5.78578 5.17303 5.56509 5.37165L0.978027 9.5" stroke="#333333" stroke-linecap="round"/>\
    </svg>\</button>',
    responsive: [
      {
        breakpoint: 1020,
        settings: {
            variableWidth: true,
            slidesToShow: 1,
            dots: true
        }
      }
    ]
});

$(".js-video").slick({
  arrows: true,
  variableWidth: true,
  centerMode: true,
  slidesToShow: 1,
  prevArrow: '<button type="button" class="slick-prev">\
  <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">\
  <path d="M0.978027 0.5L5.56509 4.62835C5.78578 4.82697 5.78578 5.17303 5.56509 5.37165L0.978027 9.5" stroke="#333333" stroke-linecap="round"/>\
  </svg>\
      </button>',
  nextArrow: '<button type="button" class="slick-next">\
  <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">\
  <path d="M0.978027 0.5L5.56509 4.62835C5.78578 4.82697 5.78578 5.17303 5.56509 5.37165L0.978027 9.5" stroke="#333333" stroke-linecap="round"/>\
  </svg>\</button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        infinite: false,
        dots: false,
      }
    }
  ]
});
$(".js-popup-close").on( "click", function() {
  let popup = $(this).parents(".js-popup");

  $(popup).removeClass("is-active");
  $("body").removeClass("is-hidden");
});

$(".js-popup-open").on( "click", function() {
  let name = $(this).data("popup");

  $(".js-popup[data-popup='"+name+"']").addClass("is-active");
  $("body").addClass("is-hidden");

  return false;
});

});